import React, { FC, useRef, useState } from 'react';
import CheckBox from 'src/components/atoms/CheckBox';
import { familyInitDataStore } from 'src/store/familyInfo';
import '../style.scss';

interface Props {}
const FamilyDescription: FC<Props> = () => {
  const checkTypeEvt = () => {};
  const familyInitResult = familyInitDataStore((state: any) => state.result);
  const familyInitBind = familyInitDataStore((state: any) => state.bind);
  const checkClickEvt = (e: any, status: string, field?: string) => {
    if (field) {
      const vType = status === 'on' ? false : true;
      familyInitResult[field] = vType;
      familyInitBind(familyInitResult);
    }
  };

  return (
    <div className="_creditcard_add_info_description">
      <div className="_grid">
        <div className="_label">
          <div className="_row">
            <div className="_col _col_pen_a">
              <div className="_tit">공제대상자</div>
            </div>
            <div className="_col _col_pen_b">
              <div className="_tit">구분</div>
            </div>
            <div className="_col _col_pen_a">
              <div className="_tit">공제금액</div>
            </div>
            <div className="_col _col_pen_a">
              <div className="_tit">공제한도</div>
            </div>
            <div className="_col _col_pen_a">
              <div className="_tit">공제대상금액</div>
            </div>
            <div className="_col _col_pen_a">
              <div className="_tit">공제금액</div>
            </div>
          </div>
        </div>

        <div className="_content">
          <div className="_row">
            <div className="_col _col_pen_a">
              <div className="_cont">근로자 본인</div>
            </div>
            <div className="_col _col_pen_a_ex _bor_l">
              <div className="_row">
                <div className="_col _col_pen_b_h">
                  <div className="_cont">연금계좌 (퇴직연금 및 연금저축)</div>
                </div>
                <div className="_col _col_pen_b_h _bor_l">
                  <div className="_cont">2001.01.01 이후 가입</div>
                </div>
                <div className="_col _col_pen_a _bor_l">
                  <div className="_cont">저축납입액</div>
                </div>
                <div className="_col _col_pen_a _bor_l">
                  <div className="_cont">
                    Min(퇴직연금납입액 + Min(연금저축납입액, 600만원), 900만원) +
                    Min(ISA추가납입액×10%, 300만원) (ISA전환금액 추가한도는 연금계좌 납입한도
                    초과시에만 적용)
                  </div>
                </div>
                <div className="_col _col_pen_a _bor_l">
                  <div className="_cont">납입금액과 공제한도 중 적은 금액</div>
                </div>
                <div className="_col _col_pen_a _bor_l">
                  <div className="_cont">
                    - 세액공제: 공제대상금액의 12% (총급여 5천5백만원 이하인 경우 15%)
                  </div>
                </div>
              </div>
              <div className="_row">
                <div className="_col _col_pen_b_h">
                  <div className="_cont">개인연금저축</div>
                </div>
                <div className="_col _col_pen_b_h _bor_l">
                  <div className="_cont">2000.12.31 이전 가입</div>
                </div>
                <div className="_col _col_pen_a _bor_l">
                  <div className="_cont">저축납입액 (분기별 300만원 한도)의 40%</div>
                </div>
                <div className="_col _col_pen_a _bor_l">
                  <div className="_cont">연 72만원</div>
                </div>
                <div className="_col _col_pen_a _bor_l">
                  <div className="_cont">납입금액</div>
                </div>
                <div className="_col _col_pen_a _bor_l">
                  <div className="_cont">- 소득공제 : Min(해당 연도의 저축 납입액x40%, 72만원)</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FamilyDescription;
